export enum PlaybackTrigger {
  /** A vocal plays itself when it arrives and carries the story on when it ends. */
  Auto = "auto",
  /** A vocal waits for the player, who advances the story by pressing play. */
  Click = "click",
}
